import React from 'react';

interface FortnoxLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const FortnoxLogo: React.FC<FortnoxLogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg
        viewBox="0 0 100 100"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle (white) */}
        <circle cx="50" cy="50" r="48" fill="white" stroke="#e5e7eb" strokeWidth="1"/>
        
        {/* Top-left arc (lime green) */}
        <path
          d="M 20 50 A 30 30 0 0 1 50 20"
          stroke="#84cc16"
          strokeWidth="8"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* Bottom-left arc (darker green) */}
        <path
          d="M 50 80 A 30 30 0 0 1 20 50"
          stroke="#16a34a"
          strokeWidth="8"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* Right-side arc (yellow/golden) */}
        <path
          d="M 80 50 A 30 30 0 0 1 50 20"
          stroke="#eab308"
          strokeWidth="8"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* Bold "F" letter */}
        <text
          x="50"
          y="65"
          textAnchor="middle"
          fontSize="48"
          fontWeight="bold"
          fill="#15803d"
          fontFamily="Arial, sans-serif"
        >
          F
        </text>
      </svg>
    </div>
  );
};

export default FortnoxLogo;